import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import HankoAuth from "../components/HankoAuth";
import AuthMarketingPanel from "../components/AuthMarketingPanel";
import AuthLayout from "../components/common/AuthLayout/AuthLayout";
import "./LoginPage.css";
import { useTranslation } from "react-i18next";
import { Dropdown, Button, Alert } from "antd";
import { DownOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { rememberPostLoginRedirectTarget } from "../utils/authRedirect";

export default function LoginPage() {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const normalizedLang = i18n.language?.split("-")[0] || "en";
    const [language, setLanguage] = useState(normalizedLang);


    useEffect(() => {
        i18n.changeLanguage(language);
    }, [language]);

    useEffect(() => {
        if (location.state?.redirectTo) {
            rememberPostLoginRedirectTarget(location.state.redirectTo);
        }
    }, [location.state]);

    const handleMenuClick = ({ key }) => {
        setLanguage(key);
    };

    const menuItems = [
        { key: "fi", label: "Suomi" },
        { key: "en", label: "English" },
        { key: "sv", label: "Svenska"},
    ];

    return (
        <AuthLayout showStepper={false}>
            <div className="auth-shell">
                <AuthMarketingPanel />
                <div className="login-box">
                    <div className="registration-info-panel auth-context-panel">
                        <div className="registration-info-panel__title">
                            <InfoCircleOutlined className="registration-info-panel__icon" />
                            <span>{t('loginPage.loginOverview.title', 'Kirjaudu Tenderaan')}</span>
                        </div>
                        <p>{t('loginPage.loginOverview.body', 'Jatka omalle Tendera-tilillesi. Jos olet uusi käyttäjä, voit luoda tilin ja rakentaa ensimmäisen hakuprofiilisi muutamassa minuutissa.')}</p>
                    </div>

                    {sessionStorage.getItem('pendingInviteToken') && (
                        <Alert
                            type="info"
                            message={t('loginPage.invitePending', "You've been invited to join a team. Log in or create an account to continue.")}
                            style={{ marginBottom: 16, textAlign: 'left' }}
                        />
                    )}

                    <HankoAuth language={language} mode="login" />

                    <div className="login-switch">
                        {t('loginPage.noAccount', "Don't have an account?")}{' '}
                        <Link to="/register">{t('loginPage.signUp', 'Sign up')}</Link>
                    </div>

                    <div className="language-container">
                        <Dropdown
                            menu={{ items: menuItems, onClick: handleMenuClick }}
                        >
                            <Button className="language-select">
                                {language === 'fi' ? 'Suomi' : language === 'sv' ? 'Svenska' : 'English'} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
}
